import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oil-chiller',
  templateUrl: './oil-chiller.component.html',
  styleUrls: ['./oil-chiller.component.scss']
})
export class OilChillerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
